//Import section
import Vue from 'vue';
// import i18n from '@/plugins/i18n';
// import vuetify from '@/plugins/vuetify';
//import router from './startup/router';
// import store from './startup/store';
import router from '@/router';
import store from '@/store';
import app from './App.vue';

import './components';
import './startup';
import './views/modules/parameters'
//Languages
import VueI18n from 'vue-i18n';
import enUS from './i18n/en-us';
import ptBR from './i18n/pt-br';
import esES from './i18n/es-es';
//Vuetify
import Vuetify from 'vuetify/lib/framework';
import appTheme from '@/themes';
//import "typeface-roboto/index.css";
import "@mdi/font/css/materialdesignicons.min.css";

//Config section
Vue.config.productionTip = false;

// i18n and vuetify Configurations
// Limpar a chave antiga de localStorage
if (localStorage.getItem('locale')) {
  localStorage.removeItem('locale');
}

// Carregar tema salvo
const savedTheme = localStorage.getItem('app-theme');
const isDark = savedTheme ? JSON.parse(savedTheme) : false;

const i18n = new VueI18n({
  locale: 'pt-BR',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {
      'pt-BR': ptBR,
      'en-US': enUS,
      'es-ES': esES,
  },
});

const vuetify = new Vuetify({
  theme: {
    dark: isDark,
    themes: appTheme,
    options: {
        customProperties: true,
        cspNonce: 'dQw4w9WgXcQ' 
    },
  },
  lang: {
      current: i18n.locale,
      t: (key, ...params) => i18n.t(key, params),
  },
});

// Carregar idioma salvo do localStorage
const savedLocale = localStorage.getItem('app-locale');
if (savedLocale) {
  i18n.locale = savedLocale;
  vuetify.framework.lang.current = savedLocale;
}

i18n.setLocale = (locale) => {
  i18n.locale = locale;
  vuetify.framework.lang.current = locale;
  localStorage.setItem('app-locale', locale);
}

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(app)
}).$mount('#app');
